import { h, resolveComponent } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'
import LayoutCard from '@/layouts/LayoutCard.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
      },
      {
        path: '/data-mahasiswa',
        name: 'Data Mahasiswa',
        component: LayoutCard,
        redirect: '/data-mahasiswa/mahasiswa',
        children: [
          {
            path: '/data-mahasiswa/mahasiswa',
            name: 'Mahasiswa',
            component: () => import('@/views/data-mahasiswa/mahasiswa.vue'),
          },
          {
            path: '/data-mahasiswa/update-biodata',
            name: 'Update Biodata',
            component: () => import('@/views/data-mahasiswa/updateBiodata.vue'),
          },
          {
            path: '/data-mahasiswa/history-pendidikan',
            name: 'History Pendidikan',
            component: () =>
              import('@/views/data-mahasiswa/historyPendidikan.vue'),
          },
          {
            path: '/data-mahasiswa/nilai-transfer',
            name: 'Nilai Transfer',
            component: () => import('@/views/data-mahasiswa/nilaiTransfer.vue'),
          },
          {
            path: '/data-mahasiswa/prestasi',
            name: 'Prestasi',
            component: () => import('@/views/data-mahasiswa/prestasi.vue'),
          },
        ],
      },
      {
        path: '/kurikulum',
        name: 'Kurikulum',
        component: LayoutCard,
        redirect: '/kurikulum/data-kurikulum',
        children: [
          {
            path: '/kurikulum/data-kurikulum',
            name: 'Data Kurikulum',
            component: () => import('@/views/kurikulum/dataKurikulum.vue'),
          },
          {
            path: '/kurikulum/mata-kuliah',
            name: 'Mata Kuliah',
            component: () => import('@/views/kurikulum/mataKuliah.vue'),
          },
          {
            path: '/kurikulum/matkul-kurikulum',
            name: 'Matkul Kurikulum',
            component: () => import('@/views/kurikulum/matkulKurikulum.vue'),
          },
          {
            path: '/kurikulum/rencana-pembelajaran',
            name: 'Rencana Pembelajaran',
            component: () =>
              import('@/views/kurikulum/rencanaPembelajaran.vue'),
          },
          {
            path: '/kurikulum/rencana-evaluasi',
            name: 'Rencanana Evaluasi',
            component: () => import('@/views/kurikulum/rencanaEvaluasi.vue'),
          },
        ],
      },
      {
        path: '/kelas-kuliah',
        name: 'Kelas Kuliah',
        component: LayoutCard,
        redirect: '/kelas-kuliah/daftar-kelas-kuliah',
        children: [
          {
            path: '/kelas-kuliah/daftar-kelas-kuliah',
            name: 'Daftar Kelas Kuliah',
            component: () => import('@/views/kelas-kuliah/kelasKuliah.vue'),
          },
          {
            path: '/kelas-kuliah/komponen-evaluasi',
            name: 'Komponen Evaluasi',
            component: () =>
              import('@/views/kelas-kuliah/komponenEvaluasi.vue'),
          },
          {
            path: '/kelas-kuliah/ajar-dosen',
            name: 'Ajar Dosen',
            component: () => import('@/views/kelas-kuliah/ajarDosen.vue'),
          },
          {
            path: '/kelas-kuliah/krs',
            name: 'KRS',
            component: () => import('@/views/kelas-kuliah/krs.vue'),
          },
        ],
      },
      {
        path: '/nilai-kuliah',
        name: 'Nilai Kuliah',
        component: LayoutCard,
        redirect: '/nilai-kuliah/daftar-nilai-kuliah',
        children: [
          {
            path: '/nilai-kuliah/daftar-nilai-kuliah',
            name: 'Daftar Nilai Kuliah',
            component: () => import('@/views/nilai-kuliah/nilaiKuliah.vue'),
          },
          {
            path: '/nilai-kuliah/nilai-komponen-evaluasi',
            name: 'Nilai Komponen Evaluasi',
            component: () =>
              import('@/views/nilai-kuliah/nilaiKomponenEvaluasi.vue'),
          },
        ],
      },
      {
        path: '/pelengkap',
        name: 'Pelengkap',
        component: LayoutCard,
        redirect: '/pelengkap/skala-nilai',
        children: [
          {
            path: '/pelengkap/skala-nilai',
            name: 'Skala Nilai',
            component: () => import('@/views/pelengkap/skalaNilai.vue'),
          },
          {
            path: '/pelengkap/periode-perkuliahan',
            name: 'Periode Perkuliahan',
            component: () => import('@/views/pelengkap/periodePerkuliahan.vue'),
          },
        ],
      },
      {
        path: '/sistem',
        name: 'Sistem',
        component: LayoutCard,
        redirect: '/sistem/data-pengguna',
        children: [
          {
            path: '/sistem/data-pengguna',
            name: 'Data Pengguna',
            component: () => import('@/views/sistem/dataPengguna.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import('@/views/pages/Page500'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/pages/Login'),
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/pages/Register'),
      },
    ],
  },
]

import { isSuperAdmin } from '@/utils/rbac'

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/sistem')) {
    if (!isSuperAdmin()) {
      return next('/dashboard')
    }
  }
  next()
})

export default router
